import { useEffect, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { frApi, fieldCls, labelCls, TIER_CLS } from "./frUtils";

const MATCH = { exact: "Recognised", alias: "Recognised (alternate name)", fuzzy: "Closest match by spelling. Please check", default: "Not in the city list: Tier 4 by default" };

/** City input with live tier recognition (server-side list, editable by management). */
export default function CityField({ value, onChange }) {
    const [hit, setHit] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!value.trim()) { setHit(null); return undefined; }
        setLoading(true);
        const t = setTimeout(() => {
            frApi.get("/resolve-city", { name: value }).then(setHit).catch(() => setHit(null)).finally(() => setLoading(false));
        }, 350);
        return () => clearTimeout(t);
    }, [value]);
    return (
        <div>
            <label className={labelCls} htmlFor="fr-city">City</label>
            <div className="relative">
                <MapPin className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input id="fr-city" value={value} onChange={(e) => onChange(e.target.value)} placeholder="e.g. Jabalpur, Bangalore, Datia"
                    data-testid="fr-city-input" autoComplete="off" className={`${fieldCls} pl-9`} />
                {loading && <Loader2 className="w-4 h-4 animate-spin text-slate-400 absolute right-3 top-1/2 -translate-y-1/2" />}
            </div>
            {hit && hit.match !== "empty" && (
                <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs" data-testid="fr-city-match">
                    <span className={`px-2 py-0.5 rounded-full border font-bold ${TIER_CLS[hit.tier]}`} data-testid="fr-city-tier">Tier {hit.tier}</span>
                    {hit.city && <span className="font-semibold text-slate-800" data-testid="fr-city-name">{hit.city}</span>}
                    <span className={hit.match === "fuzzy" ? "text-amber-700 font-semibold" : "text-slate-500"}>{MATCH[hit.match]}</span>
                </div>
            )}
        </div>
    );
}
